import { useImperativeHandle, useRef, useState } from "react";

export type ImperativeDialogRef = {
  open: () => void;
  close: () => void;
};

export function useImperativeDialogRef() {
  return useRef<ImperativeDialogRef>(null);
}

export function useImperativeDialog(
  ref: React.ForwardedRef<ImperativeDialogRef>,
  options: {
    onOpen?: () => void;
  } = {},
) {
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      setIsOpen(true);
      options.onOpen?.();
    },
    close: () => setIsOpen(false),
  }));

  return { isOpen, setIsOpen };
}
